import { render, staticRenderFns } from "./CreateEventItemCategory.vue?vue&type=template&id=c772c394&scoped=true&"
import script from "./CreateEventItemCategory.vue?vue&type=script&lang=js&"
export * from "./CreateEventItemCategory.vue?vue&type=script&lang=js&"
import style0 from "./CreateEventItemCategory.vue?vue&type=style&index=0&id=c772c394&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c772c394",
  null
  
)

export default component.exports